export default "__VITE_ASSET__BRtXlpBx__"